import { COOKIES, onceConsented } from "@telia/b2x-cookie-consent";
import { inject } from "@telia/b2x-pardot";
import { rule } from "@telia/b2x-url-segments";

import { w } from "../util";

export const initPardot = () => {
  const COOKIE_GROUP = COOKIES.pardot;

  if (w) {
    const r = rule(new URL(w.location.href));
    if (r.isB2B && r.isPublic) {
      onceConsented(COOKIE_GROUP, "Enable Pardot traffic source tracking").then(() => inject());
    }
  }
};
